import React, { useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FaAddressBook, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import iccilogo from "../../asstes/Brandimg/EAC_logowhite.png";

export default function Footer() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://agepcoatings.com/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      alert(data.message || "Subscribed successfully!");
      setFormData({ name: "", email: "" });
    } catch (error) {
      console.error(error);
      alert("Something went wrong!");
    }
  };
  return (
    <footer className="footer">
      <div className="footer-top container">
        {/* Left Section */}
        <div className="footer-col footer-about">
          <img src={iccilogo} alt="EAC" className="footer-logo" />
          <p className="footer-desc">
            EAC International LLC is a global leader in corrosion control, asset
            protection, and professional training. Through AGEP India, we
            deliver AMPP-certified programs and standards-driven engineering
            solutions that protect critical assets and advance industry
            professionals worldwide.{" "}
          </p>
          <p className="footer-subtitle">
            Protecting assets. Advancing professionals. Elevating global
            standards.
          </p>
        </div>

        {/* Middle Section */}
        <div className="footer-col footer-links">
          <h5 className="text-light">Quick Links</h5>
          <ul className="mt-3">
            <li>
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/services" onClick={() => window.scrollTo(0, 0)}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/Courses" onClick={() => window.scrollTo(0, 0)}>
                Courses
              </Link>
            </li>
            <li>
              <Link to="/Contact" onClick={() => window.scrollTo(0, 0)}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/faq" onClick={() => window.scrollTo(0, 0)}>
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/TermsOfService" onClick={() => window.scrollTo(0, 0)}>
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/PrivacyPolicy" onClick={() => window.scrollTo(0, 0)}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/RefundPolicy" onClick={() => window.scrollTo(0, 0)}>
                Refund Policy
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-col footer-locations">
          <h5 className="text-light">Contact Us</h5>
          <p>
            <FaEnvelope />info.eac-international.com
          </p>
          <p>
            <FaPhoneAlt /> +1-307-301-8385
          </p>
          <p>
            <FaAddressBook /> EAC International LLC
          </p>
          <p>5830 E 2nd Street Ste 7000 Casper, WY 82609</p>

          <div className="footer-social">
            <a
              href="https://www.instagram.com/agep_india"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/agepinternational"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.linkedin.com/company/agepindia"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://twitter.com/AGEPIndia?t=v2tFDaWa-j99yqz-kNW7rA&s=08"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-col footer-subscribe text-light">
          <h5>Contact & Subscription</h5>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <button type="submit">Subscribe Now</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom container text-light">
        <p>© 2025 EAC All rights reserved</p>
      </div>
    </footer>
  );
}
